import http from '@/utils/services/http'
import store from '../../../store'
import router from './../../../router'

/**
 * Fornece os métodos de autenticação e armazena em localStorage o token
 */

export default {
  login (email, pass, channel) {
    if (localStorage.token) {
      // if (callback) callback({authenticated: true, data: JSON.parse(localStorage.user)})
      http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.token
      return Promise.resolve({token: localStorage.token, user: JSON.parse(localStorage.user)})
    }
    return postLogin(email, pass, channel)
      .then((data) => {
        localStorage.token = data.token
        localStorage.user = JSON.stringify(data.user)
        localStorage.primeiroAcesso = data.primeiroAcesso
        localStorage.somenteConsultaReboque = data.somenteConsultaReboque
        http.defaults.headers.common['Authorization'] = 'Bearer ' + data.token
        return Promise.resolve(data)
      })
      .catch((res) => {
        return Promise.reject(res)
      })
  },

  getToken () {
    return localStorage.token
  },
  getUser () {
    return JSON.parse(localStorage.user)
  },

  logout (callback) {
    delete localStorage.token
    delete localStorage.user
    delete localStorage.primeiroAcesso
    delete localStorage.somenteConsultaReboque
    delete http.defaults.headers.common['Authorization']
    this.onChange(false)
    // Clear store in vuex
    store.dispatch('clearUserAndToken').then(() => {
      if (callback) callback()
    })
    window.location.reload()
  },

  loggedIn () {
    return !!localStorage.token
  },

  onChange () {
  }
}

const postLogin = (email, password, channel) => {
  return http.post('/api/auth', `user=${email}&pass=${password}&channel=${channel}`) //  + '&channel=client' to simulate client connection to intranet
    .then(response => {
      // Verifica se o login foi realizado com sucesso
      let userData = response.data
      return Promise.resolve(userData)
    })
    .catch(({response}) => {
      return Promise.reject(response.data)
    })
}

console.log(process.env.API_URL)
http.defaults.baseURL = process.env.API_URL

http.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  if (typeof error.response === 'undefined') {
    return Promise.reject(error)
  }
  if (error.response.data.status === 401 || error.response.status === 401) {
    if (error.response.data.detail === 'Invalid Token' || error.response.data.detail === 'Expired JWT Token') {
      console.log('TOKEN EXPIRADO! Redirecionando...')
      router.push('/logout')
      return false
    }
  }
  // Do something with response error
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/domain/auth/services/auth.js